/* eslint-disable max-len */
import { Component, Input, OnInit, ElementRef, Inject } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { AngularFirestore } from '@angular/fire/firestore';
import { format, parseISO, getDate, getMonth, getYear } from 'date-fns';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';
import { AngularFireDatabase } from '@angular/fire/database';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.scss'],
})
export class EditProfileComponent implements OnInit {

  @Input() public uid: any;
  currentUser = this.authService.currentUser;
  userForm;
  dateValue2;
  unsub1;
  interest;
  interests = [];
  expertOptions = [{ name: 'Physics' }, { name: 'Chemistry' }, { name: 'General Science' }, { name: 'Maths' }, { name: 'Hindi' }, { name: 'English' }, { name: 'Urdu' }, { name: 'Sanskrit' }, { name: 'Language' }, { name: 'Law' }, { name: 'History' }, { name: 'Arts' }, { name: 'Accounts' }, { name: 'Literature' }, { name: 'Economics' }, { name: 'Civics' }, { name: 'Geography' }, { name: 'Business Studies' }, { name: 'Physical Activities' }, { name: 'Engineering' }, { name: 'Medical Science' }, { name: 'Environmental Science' }, { name: 'Computer Science' }, { name: 'Energy Science' }, { name: 'Pharmacy' }, { name: 'Product Designing' }, { name: 'Manufacturing' }, { name: 'Programming' }, { name: 'Philosophy' }, { name: 'Psychology' }, { name: 'Drawing' }, { name: 'CAD Designing' }, { name: 'Thermodynamics' }, { name: 'Quantum Mechanics' }, { name: 'Mechanics' }, { name: 'Sociology' }, { name: 'Entrepreneurship' }, { name: 'Mechanical Engineering' }, { name: 'Electrical Engineering' }, { name: 'Civil Engineering' }, { name: 'Statistics' }, { name: 'Artificial Intelligence' }, { name: 'Aerospace' }, { name: 'Others' }];


  constructor(
    public firestore: AngularFirestore,
    public modalCtrl: ModalController,
    public authService: AuthService,
    public formBuilder: FormBuilder,
    public toastController: ToastController,
    private el: ElementRef
  ) {

  }

  ngOnInit() { }

  async ionViewDidEnter() {
    console.log('ionViewDidEnter EditProfileComponent', this.uid);
    this.unsub1 = this.authService.currentAccount.subscribe(async (currentUser) => { this.currentUser = currentUser; });
    this.userForm = this.formBuilder.group({
      displayName: [this.currentUser.displayName, [Validators.required, Validators.minLength(3)]],
      currentOrganisation: [this.currentUser.currentOrganisation, [Validators.required, Validators.minLength(3)]],
      email: [this.currentUser.email, [Validators.required, Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$')]],
      dob: [this.currentUser.dob, [Validators.required]],
      phone: [this.currentUser.phone, [Validators.required, Validators.minLength(10), Validators.minLength(10)]],
      address: [this.currentUser.address, [Validators.required, Validators.minLength(3)]],
      city: [this.currentUser.city, [Validators.required, Validators.minLength(3)]],
      country: [this.currentUser.country, [Validators.required, Validators.minLength(3)]],
      gender: [this.currentUser.gender, [Validators.required]],
      level: [this.currentUser.level, [Validators.required]],
      subjectExpert: [this.currentUser.subjectExpert, [Validators.required]],
      bio: [this.currentUser.bio, []],
      uid: [this.currentUser.uid, [Validators.required]],
      id: [this.currentUser.id],
    });
    this.interests = this.currentUser?.interests || [];
  }

  // eslint-disable-next-line @typescript-eslint/member-ordering
  get errorCtr1() {
    return this.userForm.controls;
  }

  formatDate(value) {
    return format(parseISO(value), 'MMM dd yyyy');
  }
  setInterest($event) {
    this.interest = $event.target.value;
  }

  addInterest() {
    console.log(this.interest);
    if (this.interest === '') {
      this.authService.presentToast('Enter Some interest!');
    } else {
      if (!this.interests.includes(this.interest)) {
        this.interests.push(this.interest);
        this.interest = '';
      } else {
        this.authService.presentToast('Interest Already Added!');
      }
    }
  }


  removeInterest(i) {
    this.interests.splice(i, 1);
  }

  calculateReferralCode(phoneNumber) {
    const x = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j'];
    const a = phoneNumber.slice(phoneNumber.length - 3, phoneNumber.length);
    const p = phoneNumber.slice(phoneNumber.length - 10, phoneNumber.length - 6);
    const pNumber = phoneNumber.slice(phoneNumber.length - 6, phoneNumber.length - 3);
    const alphabets = [x[a[0]], x[a[1]], x[a[2]]].reverse();
    const ranks = Array.from(p, num => Number(num)).map((v, i) => [v, i]).sort((l, b) => b[0] - l[0]).map((l, i) => [...l, i + 1]).sort((l, b) => a[1] - b[1]).map(l => a[2]);
    const indexes = [ranks.indexOf(4), ranks.indexOf(3), ranks.indexOf(2)];
    let referralCode = pNumber;
    for (let i = 0; i < alphabets.length; i++) {
      referralCode = [referralCode.slice(0, indexes[i]), alphabets[i], referralCode.slice(indexes[i])].join('');
    }
    return referralCode;
  }

  async checkPhoneUnique(phone) {
    return await this.authService.getUserByPhone(phone).then((user: any) => {
      console.log('checkPhoneUnique', user);
      if (user && user.id !== this.currentUser.id) {
        return false;
      }
      return true;
    });
  }

  async save() {
    if (this.userForm.valid) {
      const data = this.userForm.getRawValue();
      data.phone = data.phone?.toString();
      if (await this.checkPhoneUnique(data.phone)) {
        data.displayNameLower = data?.displayName?.toLowerCase();
        data.interests = this.interests;
        data.refCode = this.currentUser?.refCode;
        if (this.currentUser.phone !== data.phone || !data.refCode) {
          data.refCode = this.calculateReferralCode(data.phone);
        }
        console.log(data);
        const docRef = this.firestore.collection('accounts').doc(this.currentUser.id);
        // Atomically add a new region to the "regions" array field.
        docRef.update(data).then(() => {
          this.presentToast('Success', 'Profile updated successfully');
          this.closeModal();
        });
      } else {
        this.presentToast(`Can't use ${data?.phone}`, `This phone number is currently being use by another user`);
      }
    } else {
      Object.keys(this.errorCtr1).forEach(key => {
        console.log(this.errorCtr1[key].valid);
        if (this.errorCtr1[key].valid === false) {
          this.presentToast(`Invalid ${key}`, `Please fill the ${key} Inputs provided!`);
          const invalidControl = this.el.nativeElement.querySelector('[formcontrolname="' + key + '"]');
          if (invalidControl) {
            setTimeout(() => {
              invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 2000);
            return;
          }
        }
      });
    }
  }

  closeModal() {
    this.modalCtrl.dismiss();
  }

  async presentToast(header, message) {
    const toast = await this.toastController.create({
      header,
      message,
      position: 'middle',
      cssClass: 'spcl-toast',
      duration: 2000
    });
    await toast.present();

    const { role } = await toast.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

  ionViewDidLeave() {
    this.unsub1.unsubscribe();
  }

}
